// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

import axios from 'axios';
import apiService from '@/utils/axios';
// Update
import UpdatePlayer from '@/graphql/players/update/updatePlayer.gql';
import InsertPlayers from '@/graphql/players/insert/insertPlayers.gql';
import RemovePlayerFromTeam from '@/graphql/players/delete/removePlayerFromTeam.gql';
import UpdatePlayerStatus from '@/graphql/players/update/UpdatePlayerStatus.gql';
export default {
	state: {
		players: [] as Player[],
		playerBillingAddress: [] as any,
		totalPlayersCount: 0,
	},

	// ================ Getters ================
	getters: {
		players(state: any) {
			return state.players;
		},
		playerBillingAddress(state: any) {
			return state.playerBillingAddress;
		},
		totalPlayersCount(state: any) {
			return state.totalPlayersCount;
		  },
	},

	// ================ Mutations ================
	mutations: {
		setPlayers(state: any, players: any) {
			state.players = players;
		},
		setPlayerBillingAddress(state: any, billingAddress: any) {
			state.playerBillingAddress = billingAddress.player_billing_address;
		},
		setTotalPlayersCount(state: any, count: number) {
			state.totalPlayersCount = count;
		  },
	},

	// ================= Actions =================
	actions: {
		// =================================================
		// Get all players
		// =================================================
		async getPlayers({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query MyQuery {
						players {
							id
							first_name
							last_name
							email
							gender
							phone_number
							status
							ringer
							role
							firebase_id
							whatsapp
							zendesk_id
							city: cityByCity {
								id
								name
								country_id
								country {
									id
									name
								}
							}

							teams: join_players_teams {
								team: teamByTeam {
									id
									name
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});

			const { players } = response.data;
			commit('setPlayers', players);
			return players;
		},
		async getPlayersbyLimit({ commit }: any, { limit, offset, searchTerm, country, city }: { limit: number; offset: number; searchTerm: string; country: string; city: string }) {
			const filters: any = {
			  _or: [
				{ first_name: { _ilike: `%${searchTerm}%` } },
				{ last_name: { _ilike: `%${searchTerm}%` } },
				{ email: { _ilike: `%${searchTerm}%` } },
				{ phone_number: { _ilike: `%${searchTerm}%` } },
			  ]
			};
		  
			if (country) {
			  filters.cityByCity = { country_id: { _eq: country } };
			}
		  
			if (city) {
			  filters.cityByCity = { ...filters.cityByCity, id: { _eq: city } };
			}
		  
			const response = await apolloClient.query({
			  query: gql`
				query GetPlayers($limit: Int!, $offset: Int!, $filters: players_bool_exp) {
				  players(limit: $limit, offset: $offset, where: $filters) {
					id
					first_name
					last_name
					email
					gender
					phone_number
					status
					ringer
					role
					photo_url
					firebase_id
					whatsapp
					zendesk_id
					city: cityByCity {
					  id
					  name
					  country_id
					  country {
						id
						name
					  }
					}
					teams: join_players_teams {
					  team: teamByTeam {
						id
						name
					  }
					}
				  }
				  players_aggregate(where: $filters) {
					aggregate {
					  count
					}
				  }
				}
			  `,
			  variables: { limit, offset, filters },
			  fetchPolicy: 'no-cache',
			});
		  
			const { players, players_aggregate } = response.data;
			commit('setPlayers', players);
			commit('setTotalPlayersCount', players_aggregate.aggregate.count);
			return { players, totalCount: players_aggregate.aggregate.count };
		  },		  	
		async getAllPlayerBillingById({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query getPlayers {
						player_billing_address {
							city
							country
							id
							invoice_name
							player_id
							postcode
							statename_number
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});
			console.log('responseresponsresponsee', response);
			commit('setPlayerBillingAddress', response.data);
			return response.data;
		},
		// =================================================
		// Get player from Hasura by ID
		// =================================================

		async getPlayerById({ commit, state }: any, id: any) {
			const response = await apolloClient.query({
				query: gql`
					query getPlayers($id: uuid!) {
						players(where: { id: { _eq: $id } }) {
							id
							first_name
							last_name
							email
							gender
							phone_number
							status
							ringer
							role
							firebase_id
							whatsapp
							zendesk_id
							city: cityByCity {
								id
								name
								country_id
							}
							teams: join_players_teams {
								id
								team: teamByTeam {
									id
									name
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					id,
				},
			});
			return response.data.players[0];
		},
		async getPlayerBillingById({ commit, state }: any, id: string) {
			const response = await apolloClient.query({
				query: gql`
					query getPlayers($player_id: String!) {
						player_billing_address(where: { player_id: { _eq: $player_id } }) {
							city
							country
							id
							invoice_name
							player_id
							postcode
							statename_number
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					id,
				},
			});
			console.log('getplayerBilling', response);
			return response;
		},
		// =================================================
		// Get player from Hasura by email
		// =================================================

		async getPlayerByEmail({ commit, state }: any, email: string) {
			const response = await apolloClient.query({
				query: gql`
					query getPlayers($email: String!) {
						players(where: { email: { _eq: $email } }) {
							id
							first_name
							last_name
							email
							gender
							phone_number
							status
							ringer
							role
							firebase_id
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					email,
				},
			});

			return response.data.players[0];
		},

		// =================================================
		// Check Zendesk for a conatct with this email
		// =================================================

		async getZendeskContactByEmail({ commit }: any, email: string) {
			const res: any = await axios({
				// url: 'http://localhost:4000/lm/zendesk_user',
				url: 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/production/lm/zendesk_user',
				method: 'get',
				params: { email },
			});

			return res;
		},

		// =================================================
		// Create new Zendesk Contact for a player
		// =================================================

		async createZendeskPlayer({ dispatch }: any, data: any) {
			// if (process.env.NODE_ENV === 'production' || process.env.DEBUG_ZENDESK ) {
				const res: any = await axios({
					// url: 'http://localhost:4000/lm/zendesk_user',
					url: 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/production/lm/zendesk_user',
					method: 'post',
					data,
				});
	
				return res.data.zendeskContact.id;
			// }
			
		},

		// =================================================
		// Create new player in Hasura
		// =================================================

		async insertPlayer({ dispatch }: any, payload: any) {
			await apolloClient
				.mutate({
					mutation: InsertPlayers,
					// Parameters
					variables: {
						objects: [payload],
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getPlayers');
			return;
		},
		// =================================================
		// Update player in Hasura
		// =================================================

		async updatePlayer({ dispatch }: any, object: any) {
			await apolloClient.mutate({
				mutation: UpdatePlayer,
				// Parameters
				variables: {
					id: object.id,
					object,
				},
			});

			return;
		},
		async updatePlayerStatus({ dispatch }: any, object: any) {
		const{data} = 	await apolloClient.mutate({
				mutation: UpdatePlayerStatus,
				// Parameters
				variables: {
					id: object.id,
					status: object.status,
				},
			});
			return data;
		},
		// =================================================
		// Remove player from team
		// =================================================

		async removePlayerFromTeam({ dispatch }: any, id: any) {
			await apolloClient
				.mutate({
					mutation: RemovePlayerFromTeam,
					// Parameters
					variables: {
						id,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return;
		},

		// =================================================
		// Delete player
		// =================================================

		async removeZendeskIdFromHasura(_: any, playerId: string) {
			await apolloClient.mutate({
				mutation: gql`
					mutation removeZendeskIdFromHasura($id: uuid!) {
						update_players(_set: { zendesk_id: null }, where: { id: { _eq: $id } }) {
							affected_rows
						}
					}
				`,
				variables: {
					id: playerId,
				},
			});
		},

		async removeFirebaseIdFromHasura(_: any, playerId: string) {
			await apolloClient.mutate({
				mutation: gql`
					mutation removeZendeskIdFromHasura($id: uuid!) {
						update_players(_set: { firebase_id: null }, where: { id: { _eq: $id } }) {
							affected_rows
						}
					}
				`,
				variables: {
					id: playerId,
				},
			});
		},

		async deletePlayer({ dispatch }: any, { player, hasura, firebase, zendesk }: any) {
			const data = { player, hasura, firebase, zendesk };
			let res: any = '';
			let res2: any = '';
			let res3: any = '';
			!hasura && zendesk && ( await dispatch('removeZendeskIdFromHasura', player.id));
			!hasura && firebase && ( await dispatch('removeFirebaseIdFromHasura', player.id));
			console.log('hasura status:', player, hasura, firebase, zendesk);
			if (hasura) {
				res3 = await apolloClient.mutate({
					mutation: gql`
						mutation DeleteplayerBookingsSchedule($id: uuid!) {
							delete_player_booking_schedules(where: { player_booking: { player_id: { _eq: $id } } }) {
								returning {
									id
								}
							}
						}
					`,
					variables: {
						id: player.id,
					},
				});

				res2 = await apolloClient.mutate({
					mutation: gql`
						mutation DeleteplayerBookings($player_id: uuid!) {
							delete_player_bookings(where: { player_id: { _eq: $player_id } }) {
								returning {
									player_id
								}
							}
						}
					`,
					variables: {
						player_id: player.id,
					},
				});
				res = await apolloClient.mutate({
					mutation: gql`
						mutation deletePlayer($id: uuid!) {
							delete_players(where: { id: { _eq: $id } }) {
								returning {
									id
								}
							}
						}
					`,
					variables: {
						id: player.id,
					},
				});
			}
			const res1 = await apiService.delete('lm/player', {
				data,
			});
			// console.log('res', res1, res2, res3);
			return res1;
		},
	},
};
